/*
 * @LineStart: -------------------------------------------
 * @Organization: TAL-R&D
 * @Mode Name:
 * @Author: FW
 * @Date: 2021-03-09 15:50:49
 * @LastEditTime: 2021-03-09 16:04:10
 * @Description: 生成UUID随机唯一码
 * @LineEnd: ----------------------------------------------
 */
export const creatUuid = () => {
  return (
    "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }) +
    "-" +
    new Date().valueOf()
  );
};
